export function Spinner({ size = "md" }: { size?: "sm" | "md" | "lg" }) {
  const s = { sm: "w-4 h-4 border-2", md: "w-6 h-6 border-2", lg: "w-10 h-10 border-3" }
  return (
    <div className={`${s[size]} border-gray-200 border-t-zimrah-600 rounded-full animate-spin`} />
  )
}

export function LoadingRow({ cols }: { cols: number }) {
  return (
    <tr>
      <td colSpan={cols}>
        <div className="flex items-center justify-center gap-3 py-12 text-gray-400">
          <Spinner />
          <span className="text-sm">Loading...</span>
        </div>
      </td>
    </tr>
  )
}

export function PageLoader() {
  return (
    <div className="flex items-center justify-center h-64 gap-3 text-gray-400">
      <Spinner size="lg" />
      <span className="text-sm">Loading...</span>
    </div>
  )
}